import { defineMessages } from "react-intl";

export const messages = defineMessages({
	publishTitle: {
		id: "kd.header.publish.title",
		defaultMessage:
			"Páciens adatainak megosztása a transzplantációs bizottsággal"
	},
	publish: {
		id: "kd.header.publish",
		defaultMessage: "Várólistára küldés"
	},
	publishWarning: {
		id: "kd.header.publish.warning",
		defaultMessage:
			"Biztos benne, hogy a páciens adatait meg szeretné osztani a transzplantációs bizottsággal?"
	},
	publishCancel: {
		id: "kd.header.publish.cancel",
		defaultMessage: "Mégse"
	},
	publishProceed: {
		id: "kd.header.publish.proceed",
		defaultMessage: "Megosztás"
	},
	publishSuccess: {
		id: "kd.header.publish.success",
		defaultMessage: "Sikeres megosztás."
	}
});
